import { PlanType } from '@showbie-socrative/socrative-utils';
import { QueryClient } from '@tanstack/react-query';

import { QUIZ_LIMIT_QUERY_KEY } from '~teacher/hook';
import { updateQuizLimit } from '~teacher/hook/useQuizLimit/cacheUpdater/updateQuizLimitCache';
import { proCheck } from '~teacher/util/proCheck';

import { QuizLimit } from '../../../../api/quiz';
import { isPositiveInteger } from '../../../../util/math';

export function updateQuizCount(
  queryClient: QueryClient,
  amountToChange: number
) {
  const currentQuizLimit =
    queryClient.getQueryData<QuizLimit>(QUIZ_LIMIT_QUERY_KEY);
  if (!currentQuizLimit) return; // no data to update

  const userPlan = proCheck.userPlan();
  if (
    [
      PlanType.FreeLegacy,
      PlanType.Pro,
      PlanType.Organization,
      PlanType.Complete,
      PlanType.Essentials,
    ].includes(userPlan)
  ) {
    return; // pro, or legacy free, nothing to update
  }

  if (amountToChange !== 0 && !isPositiveInteger(amountToChange))
    throw new Error('Invalid Quiz Count update');

  queryClient.setQueryData<QuizLimit>(
    QUIZ_LIMIT_QUERY_KEY,
    updateQuizLimit(amountToChange)
  );
}
